import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { MdLockOpen } from "react-icons/md";

const ConfirmUnblockModal = ({
  show,
  onClose,
  onConfirm,
  title = "Unblock User",
  message = "Are you sure you want to unblock this user?",
  confirmText = "Yes, Unblock",
  cancelText = "Cancel",
  loading = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="sm"
    >
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">{title}</h5>
        <button className="btn" onClick={onClose} disabled={loading}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />

      <Modal.Body className="text-center pt-2">
        <div className="delete-icon-wrapper mb-3">
          <MdLockOpen size={38} />
        </div>
        <p className="delete-message">{message}</p>
      </Modal.Body>

      <div className="modal-footer border-0 justify-content-center">
        <button
          className="btn btn-light px-4"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </button>

        <button
          className="btn btn-success px-4"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Unblocking..." : confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmUnblockModal;

